import script from "./RestaurantPosInvoiceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RestaurantPosInvoiceModal.vue?vue&type=script&setup=true&lang=js"

import "./RestaurantPosInvoiceModal.vue?vue&type=style&index=0&id=11d4af5c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11d4af5c"]])

export default __exports__